import React, { useState,useEffect } from "react";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../components/Theme";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import ShowerIcon from "@mui/icons-material/Shower";
import FireExtinguisherIcon from "@mui/icons-material/FireExtinguisher";
import AttractionsIcon from "@mui/icons-material/Attractions";
import WateringTable from "./operation_component/Water";
import FertilizingTable from "./operation_component/Fertilizing";
import Chemical from "./operation_component/Chemical";
import Harvest from "./operation_component/Harvest";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import FertilizerStockTable from "./stock_component/Fertilizing";
import ChemicalStockTable from "./stock_component/Chemical";
import EquipmentStockTable from "./stock_component/Equipment";

const eventItems = [
  { label: "คลังปุ๋ย", icon: ShowerIcon, key: "fertilizer" },
  { label: "คลังสารเคมี", icon: FireExtinguisherIcon, key: "chemical" },
  { label: "คลังเครื่องจักร", icon: AgricultureIcon, key: "equipment" },
];

const Stock = ({ appCropId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedMenu, setSelectedMenu] = useState("fertilizer");
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    if (appCropId) {
      // fetch data ตาม appCropId
    }
  }, [appCropId]);
  const renderContent = () => {
    switch (selectedMenu) {
      case "fertilizer":
        return <FertilizerStockTable appCropId={appCropId} />;
      case "chemical":
        return <ChemicalStockTable appCropId={appCropId} />;
      case "equipment":
        return <EquipmentStockTable appCropId={appCropId} />;
      default:
        return <Typography>กรุณาเลือกเมนู</Typography>;
    }
  };

  return (
    <Box>
      <Grid container spacing={2} p={isMobile ? 2 : 6}>
        {eventItems.map((item) => {
          const isActive = selected === item.key;

          return (
            <Grid item size={{ xs: 6, md: 6, lg: 4, xl: 4 }} key={item.key}>
              <Box
                onClick={() => {
                  setSelected(item.key);
                  setSelectedMenu(item.key);
                }}
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap={isMobile ? 0.5 : 1}
                p={isMobile ? 1 : 2}
                border="2px solid"
                borderColor={isActive ? colors.greenAccent[400] : "transparent"}
                borderRadius="12px"
                sx={{
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  backgroundColor: isActive
                    ? colors.greenAccent[400]
                    : theme.palette.background.paper,
                  "&:hover": {
                    backgroundColor: colors.greenAccent[400],
                    "& .text, & .icon": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <item.icon
                    className="icon"
                    sx={{
                      ml: "10px",
                      color: isActive ? "#fff" : colors.greenAccent[400],
                      transition: "color 0.3s ease",
                      fontSize: isMobile ? "15px" : "none",
                    }}
                  />
                  <Typography
                    className="text"
                    fontWeight="bold"
                    sx={{
                      fontSize: isMobile ? "14px" : "none",
                      color: isActive ? "#fff" : "#000",
                      transition: "color 0.3s ease",
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      {renderContent()}
    </Box>
  );
};

export default Stock;
